import { SkeletonTable } from '@optools/components/loading/skeleton-table';
import { Skeleton } from '@optools/components/ui/skeleton';

export function ESNIRulesTableSkeleton() {
  return (
    <div className="p-2" data-testid="esni-rules-table-skeleton">
      <div className="mb-4 flex items-center gap-2">
        {Array.from({ length: 4 }).map((_, index) => (
          <Skeleton key={index} className="h-6 w-24" />
        ))}
      </div>
      <SkeletonTable columns={5} rows={10} />
    </div>
  );
}
